import { Grid } from "@mui/material";
import { useScopeOfWork } from "../../context/ScopeOfWorkContext";
import { TypeOfServiceCard } from "./TypeOfServiceCard";
import { Service } from "../../context/scope-of-work.types";
import { useTypeOfServiceQuery } from "./hooks/useTypeOfServiceQuery";
import { QueryState } from "../../../../query-states/GlobalQueryState";

interface TypeOfServiceProps {
  selected: Service | null;
  categoryType?: string;
}

export const TypeOfService = ({ selected, categoryType }: TypeOfServiceProps) => {
  const { dispatch } = useScopeOfWork();
  const { isLoading, isError, data: services } = useTypeOfServiceQuery({ categoryType });

  const safeTypeOfServices = services?.items ?? [];

  const handleSelectService = (service: Service) => {
    dispatch({ type: "SET_SERVICE", payload: service });
  };

  if (!categoryType) return null;

  <QueryState isLoading={isLoading} isError={isError} serviceName="type of service" />;

  return (
    <Grid container spacing={2}>
      {safeTypeOfServices?.map((service) => (
        <Grid item xs={12} sm={6} md={4} key={service.uid}>
          <TypeOfServiceCard service={service} selected={selected} onSelect={handleSelectService} />
        </Grid>
      ))}
    </Grid>
  );
};
